import { EntityType } from './entityType'
import { Button, Col, Container, Row } from 'react-bootstrap';



interface EntityCardProps {
    data: EntityType,
    //parentFunction: Function,
}

const EntityCard = (props: EntityCardProps) => {

    //const OpenURL = (url: string) => {
    const OpenURL = (url: EntityType) => {

        console.log("Opening URL:", url);
        window.open(url.link?.uri, "_blank");
    }

    return (
        <Container className='entity-card'>
            <Row className="align-items-center">
                <Col>
                    <Container>
                        <Row>
                            <Col>
                                <span className={props.data.mention.label + ' entity-label'}>{props.data.mention.label}</span> {props.data.mention.entity_text}
                            </Col>
                        </Row>
                        <Row>
                            <Col className='entity-sub-row'>
                                {props.data.link?.score &&
                                    <span title={props.data.link?.score.toString()}>{props.data.link?.entity_name} &#183; Confidence score: {props.data.link.confidence}</span>
                                }
                            </Col>
                            </Row>
                    </Container>
                </Col>
                <Col xs={4}>
                    { props.data.link?.uri &&
                    <Button variant="secondary" size="sm" onClick={() => OpenURL( props.data )}>Open Wikidata</Button>
                    }
                </Col>
            </Row>
        </Container>

    );
};

export default EntityCard;